import "./src/styles/global.css"
import * as React from "react"
import { AuthProvider } from "./src/contexts/AuthContext"

export const wrapRootElement = ({ element }) =>
  <AuthProvider>
    {element}
  </AuthProvider>
